import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { FC } from "react";

import { DirectionsServiceEnum, PROVIDER_OPTIONS } from "@ryde/shared";

import { RebuildRouteProviderIndicators } from "./rebuild-route-provider-indicators";

export interface IRebuildRouteProviderSelectorProps {
  selectedProvider: DirectionsServiceEnum | null;
  systemDefaultProvider: DirectionsServiceEnum;
  lastUsedProvider?: DirectionsServiceEnum | null;
  showLastUsedBadge?: boolean;
  onProviderChange: (provider: DirectionsServiceEnum) => void;
}

export const RebuildRouteProviderSelector: FC<
  IRebuildRouteProviderSelectorProps
> = ({
  selectedProvider,
  systemDefaultProvider,
  lastUsedProvider,
  showLastUsedBadge = true,
  onProviderChange,
}) => {
  return (
    <div className="rebuild-route-dropdown-providers">
      <RadioGroup
        value={selectedProvider || ""}
        onChange={e =>
          onProviderChange(e.target.value as DirectionsServiceEnum)
        }
      >
        {PROVIDER_OPTIONS.map(provider => (
          <FormControlLabel
            key={provider.value}
            value={provider.value}
            control={<Radio size="small" />}
            label={
              <span className="rebuild-route-provider-label">
                {provider.label}
                <RebuildRouteProviderIndicators
                  providerValue={provider.value}
                  systemDefaultProvider={systemDefaultProvider}
                  lastUsedProvider={
                    showLastUsedBadge ? lastUsedProvider : undefined
                  }
                />
              </span>
            }
          />
        ))}
      </RadioGroup>
    </div>
  );
};
